export default __webpack_public_path__ + "static/media/Circle.0f92d32a.svg";